<div class="mzic-option-md-mekari">
  <mzic-search-spotify-avatar
    altImage="MZIC artist thumbnail"
    [imageUri]="optionData.imageUri" />
  <p class="mzic-option-md-mekari__text">{{ optionData.name }}</p>
</div>
